import React, { PropsWithChildren } from "react";

interface Props {
  isOpen: boolean;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  className?: string;
}

const Overlay: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="fixed inset-0 bg-black/50 z-[5000] flex items-center justify-center">
      {children}
    </div>
  );
};

export const CloseIcon: React.FC<{
  className?: string;
  onClick?: () => void;
}> = ({ className, onClick }) => {
  return (
    <svg
      onClick={onClick}
      className={className}
      viewBox="0 0 21.46 19.34"
    >
      <path d="M8.16,9.97L.6,19.04H5.14l3.32-4.23c.91-1.21,1.51-2.12,2.42-3.32h.3c.6,1.51,1.51,2.42,2.12,3.63l3.02,4.23h4.53l-7.56-9.67L21.46,0h-4.53l-3.63,4.53c-.91,1.21-1.81,2.42-2.72,3.32h-.3c-.91-.91-1.51-2.12-2.42-3.32L4.53,0H0L8.16,9.97Z" />
    </svg>
  );
};

export const Close: React.FC<{
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
}> = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="right-0 top-0 ml-auto flex items-center gap-1 text-sm text-gray"
      aria-label="Close"
    >
      <CloseIcon className="w-4 fill-gray" />
      CLOSE
    </button>
  );
};

const Modal: React.FC<React.PropsWithChildren<Props>> = ({
  isOpen,
  onClick,
  className = "",
  children,
}) => {
  if (!isOpen) return null;

  return (
    <div
      role="dialog"
      onMouseEnter={(e) => e.stopPropagation()}
      onMouseLeave={(e) => e.stopPropagation()}
      onClick={onClick}
      className={`fixed inset-0 z-[5000] flex items-center justify-center ${className}`}
    >
      {children}
    </div>
  );
};

export const ModalWithOverlay: React.FC<React.PropsWithChildren<Props>> = ({
  isOpen,
  onClick,
  className = "",
  children,
}) => {
  if (!isOpen) return null;

  return (
    <Overlay>
      <Modal
        isOpen={isOpen}
        onClick={onClick}
        className={className}
      >
        {children}
      </Modal>
    </Overlay>
  );
};

export default Modal;
